import React from 'react';

function App() {
	return (
		<div className='App' style={{ marginTop: '5rem' }}>
			Website migrated to <a href='https://akashdutta.tech/'> www.akashdutta.tech</a>
		</div>
	);
}

export default App;
